"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableLineCreateBinding = drawableLineCreateBinding;
const mobx_1 = require("mobx");
const id_1 = require("../../id");
const line_drawable_1 = require("../../model/collection/drawable/line.drawable");
const label_draw_svg_1 = require("../drawable/label.draw.svg");
const util_1 = require("../util");
const START_DELTA = { x: -100, y: 0 };
const END_DELTA = { x: 100, y: 0 };
const LABEL_DELTA = { x: 150, y: 150 };
function getLabelPoint(dc, center) {
    const uiScale = dc.state.scale;
    return (0, util_1.movePoint)(center, LABEL_DELTA, dc.capture.resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale,
    });
}
function createLineAt(dc, center) {
    const labelPoint = getLabelPoint(dc, center);
    const startPoint = (0, util_1.movePoint)(center, START_DELTA, dc.capture.resolution);
    const endPoint = (0, util_1.movePoint)(center, END_DELTA, dc.capture.resolution);
    const { start } = line_drawable_1.CollectionModelDrawableLine.createWithLinePointsAndLabel(dc.drawState, id_1.IkeId.generate(), startPoint, endPoint, labelPoint);
    dc.state.setSelected(start.id, null);
}
function drawableLineCreateBinding(dc, evt) {
    if (evt.drawableId == null) {
        (0, mobx_1.runInAction)(() => createLineAt(dc, evt.center));
        return;
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=line.create.binding.js.map